import React from 'react';

export function KeyboardArrowLeftIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M30.82 33.18L21.66 24l9.16-9.18L28 12 16 24l12 12 2.82-2.82z" />
    </svg>
  );
}
